import { render, staticRenderFns } from "./EmergencyServices.vue?vue&type=template&id=6ed20288&scoped=true"
import script from "./EmergencyServices.vue?vue&type=script&lang=js"
export * from "./EmergencyServices.vue?vue&type=script&lang=js"
import style0 from "./EmergencyServices.vue?vue&type=style&index=0&id=6ed20288&prod&scoped=true&lang=css"
import style1 from "./EmergencyServices.vue?vue&type=style&index=1&id=6ed20288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed20288",
  null
  
)

export default component.exports